var codeblock_default = {
  "blockStyleSpacing": "BOVBy",
  "codeBlock": "NQFS1 BOVBy",
  "renderedInTable": "ZiBC3"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
